<script lang="ts">
    import { Navigation } from '../../utilities/Navigation';
    import { get } from 'svelte/store';
    import { onMount } from 'svelte';
    import { _ } from 'svelte-i18n';

    import { TacticalPlanApi, type TacticalPlanResponseType } from './TacticalPlanApi';
    import TacticalPlanList from './TacticalPlanList.svelte';
    import FilterTacticalPlan from '../Filter/FilterTacticalPlan.svelte';
    import { currentMainFilter, filter } from '../../../stores/filter';
    import TemplateStandard from '../../shared/TemplateStandard.svelte';
    import IconAdd from '../../shared/Icons/IconAdd.svelte';
    import { WeekSchedule } from '../../utilities/WeekSchedule';
    import ErrorInline from '../../shared/ErrorInline.svelte';
    import { week } from '../../utilities/mockWeekSchedule';
    import { mainMenu, tacticalPlanStore } from '../../../stores/store';
    import Separator from '../../shared/Separator.svelte';
    import { api } from '../../../stores/api';
    import { TacticalPlanRuleApi } from './TacticalPlanRuleApi';
    import { getEmptyDefaultRule } from './TacticalPlanRule';
    import ButtonMain from '../../shared/ButtonMain.svelte';
    import MessageNotFound from '../../shared/Messages/MessageNotFound.svelte';
    import Spinner from '../../shared/Spinner/Spinner.svelte';
    import { TacticalPlan } from './TacticalPlan';
    import ButtonAddSomething from '../../shared/ButtonAddSomething.svelte';
    import TemplateHeaderTrio from '../../shared/TemplateHeaderTrio.svelte';
    import FilterVehicles from '../Filter/FilterVehicles.svelte';
    import TemplateHeaderDuo from '../../shared/TemplateHeaderDuo.svelte';
    import { ApiFilterBuilder } from '@automapa/svelte-automapa-template';
    import { createTacticalPlan } from './createTacticalPlan';
    import { features } from '../../shared/Features/features';
    import { SettingsApi } from '../Settings/SettingsApi';
    import {
        tactical_plan_rules_filter_config,
    } from '../../../stores/api';

    let tacticalPlans: TacticalPlan[] = [];
    let error: string = '';
    let loadingCountVehicles: boolean = true;
    let loadingCountMaps: boolean = true;
    let loading: boolean = true;
    let f: ApiFilterBuilder = new ApiFilterBuilder(null);
    let tacticalPlansTemp: TacticalPlan[] = [];
    let disableChanging: boolean = false;

    // function getFirstNotSetWeekDay(week, bitSum: number): number {
    //     for (let day of week) {
    //         if (!WeekSchedule.isChecked(day.id, bitSum)) {
    //             return day.id;
    //         }
    //     }
    //     return 0;
    // }

    // function createTacticalPlan() {
    //     TacticalPlanApi.createOne(get(api), {
    //         name: $_('New tactical plan'),
    //         week_schedule: getFirstNotSetWeekDay(
    //             week,
    //             WeekSchedule.getSum(tacticalPlans.map(tp => tp.getWeekSchedule()))
    //         ),
    //     })
    //         .then(response => {
    //             let newTP = response;
    //             let firstRule = getEmptyDefaultRule(newTP.id);
    //             firstRule.setAlwaysLast();
    //             firstRule.selectActionType('unset');
    //             TacticalPlanRuleApi.createOne(get(api), firstRule.getRuleReadyToRequest())
    //                 .then(response => {
    //                     // tacticalPlans = [...tacticalPlans, newTP];
    //                     tacticalPlans = [...tacticalPlans, new TacticalPlan(newTP)];
    //                     Navigation.navigate(`/tactical-plan/${newTP.id}`);
    //                 })
    //                 .catch(error => {
    //                     console.log(error);
    //                 });
    //         })
    //         .catch(error => {
    //             console.log(error);
    //         });
    // }

    function onUpdateOne(updatedPlans?: TacticalPlanResponseType[]) {
        if (updatedPlans && updatedPlans.length > 0) {
            // Lekka aktualizacja: stosujemy odpowiedzi PATCH bezpośrednio na lokalnych obiektach.
            // Nie pobieramy ponownie listy planów ani statystyk (countVehicle/countMap nie zmienia
            // się przy zmianie week_schedule).
            const updateMap = new Map<number, TacticalPlanResponseType>(
                updatedPlans.map(u => [u.id, u])
            );
            tacticalPlans = tacticalPlans.map(tp => {
                const tpId = tp.getId();
                if (tpId !== null) {
                    const update = updateMap.get(tpId);
                    if (update) {
                        const newTp = new TacticalPlan(update);
                        newTp.setCountVehicle(tp.getCountVehicle());
                        newTp.setCountMap(tp.getCountMap());
                        return newTp;
                    }
                }
                return tp;
            });
        } else {
            reloadElements();
        }
    }

    function reloadElements() {
        loading = true;
        disableChanging = true;
        console.log('reloadElements');
        Promise.all([
            TacticalPlanApi.filter(get(api), f),
            SettingsApi.getFilterConfig($api, 'tactical_plan_rule')
        ])
            .then(([res, filter_config]) => {
                $tactical_plan_rules_filter_config = filter_config || null;

                tacticalPlansTemp = res.map(tp => new TacticalPlan(tp));

                let promisesVehicles: Promise<{ vehicles: number; zones: number }>[] = [];
                tacticalPlansTemp.forEach(tp => {
                    promisesVehicles.push(TacticalPlanApi.getStats(get(api), tp.getId()));
                });

                Promise.all(promisesVehicles)
                    .then(counts => {
                        console.log('PageTacticalPlan, countVehicles', counts);
                        counts.forEach((count, index) => {
                            tacticalPlansTemp[index].setCountVehicle(count.vehicles);
                            tacticalPlansTemp[index].setCountMap(count.zones);
                        });
                        tacticalPlansTemp = [...tacticalPlansTemp];
                    })
                    .catch(err => {
                        error = err;
                    })
                    .finally(() => {
                        disableChanging = false;
                        loadingCountVehicles = false;
                        loadingCountMaps = false;
                        loading = loadingCountVehicles || loadingCountMaps;
                    });
            })
            .catch(err => {
                error = err;
                loadingCountMaps = false;
                loadingCountVehicles = false;
                loading = loadingCountVehicles || loadingCountMaps;
                disableChanging = false;
            })
            .finally(() => {
                if ($features.feature_ux_improvements) {
                    let pageTacticalPlanItem = $mainMenu.items.find((i) => i.id == 'PageTacticalPlan');
                    if (pageTacticalPlanItem?.notification) {
                        pageTacticalPlanItem.notification.reload = true;
                        $mainMenu = $mainMenu;
                    }
                }
            });
    }

    onMount(() => {
        $mainMenu.currentPage = 'PageTacticalPlan';
        $currentMainFilter = null;

        reloadElements();

        return () => {
            $currentMainFilter = null;
        };
    });

    // $: {
    //     // f.clearFilterBy().addFilterByStringILike('name', $filter.tacticalPlan.query);
    //     reloadElements();
    // }

    $: {
        if (!loading) {
            console.log(
                'PageTacticalPlan',
                tacticalPlansTemp,
                loadingCountVehicles,
                loadingCountMaps,
                loading
            );
            tacticalPlans = [...tacticalPlansTemp];
        }
    }

    $: {
        if ($tacticalPlanStore.forceReload) {
            $tacticalPlanStore.forceReload = false;
            reloadElements();
        }
    }
</script>

<TemplateStandard>
    <div slot="submenu"></div>
    <div slot="header" style="width: 100%;">
        <TemplateHeaderDuo>
            <div slot="main-header">
                {$_('Tactical plans')}
            </div>
            <div slot="main-buttons">
                <ButtonAddSomething
                    text={$_('Add plan')}
                    on:click={() => {
                        createTacticalPlan(get(api), tacticalPlans);
                    }}
                />
            </div>
        </TemplateHeaderDuo>
    </div>
    <div slot="content-header"></div>
    <div slot="content">
        {#if loadingCountMaps || loadingCountVehicles}
            <Spinner />
        {:else}
            {#if error}
                <ErrorInline text={error} />
            {/if}
            <!--{#if tacticalPlans.length > 5}-->
            <!--    <Separator />-->
            <!--    <FilterTacticalPlan />-->
            <!--{/if}-->
            {#if tacticalPlans.length === 0}
                <div
                    style="display: flex; justify-content: center; align-items: center;min-height: 200px; padding: 30px; flex-direction: column;"
                >
                    <MessageNotFound text={$_('No tactical plan found')} />
                    <ButtonMain
                        text={$_('Create tactical plan')}
                        showIcon={false}
                        on:click={() => {
                            createTacticalPlan(get(api), tacticalPlans);
                        }}
                    />
                </div>
            {:else}
                <div style="padding-top:40px;">
                    <TacticalPlanList
                        bind:tacticalPlans
                        {reloadElements}
                        {onUpdateOne}
                        loading={false}
                        bind:disableChanging={disableChanging}
                    />
                </div>
            {/if}
        {/if}
    </div>
</TemplateStandard>

<style>
</style>
